import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../libs'
import { ClientPurseItem, ClientGroupedPurseRequest } from './types'
import {
  setRequestError,
  setRequestSuccess,
} from '../../../features/notifications'

// Событие для обновления списка кошельков
export const clientGroupedPursesListMounted =
  createEvent<ClientGroupedPurseRequest>()

const clientGroupedPursesRequestStarted =
  createEvent<ClientGroupedPurseRequest>()

export const unGroupClientPurseMounted = createEvent<{
  clientPursesIds: number[]
}>()

export const unGroupClientPurse = fx<
  {
    clientPursesIds: number[]
  },
  any
>({
  method: 'POST',
  url: `/client_purse/ungroup_client_purse`,
})

// Эффект для получения данных
export const getClientPurses = fx<void, ClientPurseItem[]>({
  method: 'GET',
  url: `/client_purse/grouped_statistic`,
})

// The compact widget and the grouped-purses tab can mount in the same render.
// Keep the request identity to avoid starting the same in-flight request twice.
const $lastClientPursesRequestKey = restore(
  clientGroupedPursesRequestStarted.map((request) => JSON.stringify(request)),
  null,
).reset(getClientPurses.finally)

// Стейт для хранения данных о кошельках
export const $clientGroupedPurses = restore<ClientPurseItem[]>(
  getClientPurses.doneData.map((response) => response.body),
  [],
)

// Обработка запроса и обновление стейта
sample({
  clock: clientGroupedPursesListMounted,
  source: $lastClientPursesRequestKey,
  filter: (lastRequestKey, request) =>
    lastRequestKey !== JSON.stringify(request),
  fn: (_, request) => request,
  target: clientGroupedPursesRequestStarted,
})

sample({
  clock: clientGroupedPursesRequestStarted,
  fn: ({
    clientId,
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    searchedColumn,
  }: ClientGroupedPurseRequest) => {
    const query: Record<string, string> = {}

    if (limit) query['limit'] = String(limit)
    if (page) query['page'] = String(page)

    let whereObj: any = {
      clientId,
    }
    // @ts-ignore
    query['where'] = JSON.stringify({ clientId })

    if (orderBy) {
      query['order'] = (orderDirection ?? '') + orderBy
    }

    if (searchText) {
      // @ts-ignore
      whereObj = {
        ...whereObj,
        searchedColumn: searchText,
      }
    }

    query['where'] = JSON.stringify(whereObj)

    return {
      query,
    }
  },
  target: getClientPurses,
})

sample({
  // @ts-ignore
  clock: unGroupClientPurseMounted,
  fn: ({ clientPursesIds }) => {
    return {
      url: '/client_purse/ungroup_client_purse',
      body: {
        clientPursesIds,
      },
    }
  },
  target: unGroupClientPurse,
})

sample({
  clock: unGroupClientPurse.doneData,
  fn: () => {
    return true
  },
  target: [setRequestSuccess],
})

sample({
  clock: unGroupClientPurse.failData,
  fn: (failData) => {
    return { message: failData.body.message, code: failData.status }
  },
  target: [setRequestError],
})
